import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useLayoutEffect } from 'react';
import { ScreenReaderOnly } from '../utils/sr-only.js';

/**
 * AnnouncementPrimitive is an unstyled (“headless”) component that handles role=status functionality and a11y concerns.
 * Use AnnouncementPrimitive for arbitrarily styled live regions containing advisory information for the user that is not important enough to be an alert
 *
 * @see https://fpl.figma.design/primitives/announcement/
 */
const AnnouncementPrimitive = forwardRef(({ children, role = 'status', screenReaderOnly, ...props }, ref) => {
    const [firstRender, setFirstRender] = useState(true);
    useLayoutEffect(() => setFirstRender(false), []);
    const message = (jsx("div", { "data-fpl-component": "primitive", "aria-relevant": "all", ...props, ref: ref, role: role, children: firstRender ? null : children }));
    // Important: <ScreenReaderOnly> is the outer wrapper, as the inner <div> may affect layout
    return screenReaderOnly ? jsx(ScreenReaderOnly, { children: message }) : message;
});
AnnouncementPrimitive.displayName = 'AnnouncementPrimitive';

export { AnnouncementPrimitive };
//# sourceMappingURL=announcement-primitive.js.map
